import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchActivePackages = async (params = {}) => {
  const res = await apiClient.get(`/subscription-packages/active`, { params });
  return res.data?.data || [];
};

export const fetchPackageById = async (id) => {
  const res = await apiClient.get(`/subscription-packages/get_by_id/${id}`);
  return res.data?.data || null;
};

export const fetchPackages = async (params = {}) => {
  const res = await apiClient.get(`/subscription-packages/get_all`, {
    ...getAuthHeader(),
    params,
  });
  return res.data?.data || [];
};

export const createPackage = async (payload) => {
  return apiClient.post(`/subscription-packages/create`, payload, {
    ...getAuthHeader(),
    headers: { "Content-Type": "application/json", ...getAuthHeader().headers },
  });
};

export const updatePackage = async (id, payload) => {
  return apiClient.post(`/subscription-packages/update/${id}`, payload, {
    ...getAuthHeader(),
    headers: { "Content-Type": "application/json", ...getAuthHeader().headers },
  });
};

export const deletePackageById = async (id) => {
  return apiClient.delete(`/subscription-packages/delete/${id}`, getAuthHeader());
};
